<template>
  <div
    class="bg-static-default-low border-static-default-mid body-2-bold flex items-center justify-center gap-4 border-2 px-6 py-4"
    :class="{
      '!bg-static-default-hi-disabled !text-static-default-low cursor-not-allowed !border-transparent':
        disabled,
    }"
    :data-test="`flag-display-${market}`"
  >
    <Flag
      v-if="isCountry"
      :aria-label="`flag-${market}`"
      :country-code="market as MarketCountryCode"
      size="xl"
    />
    <span>{{ market }}</span>
  </div>
</template>

<script setup lang="ts">
import { MarketCountryCode } from '@backmarket/http-api'

withDefaults(
  defineProps<{
    market: MarketCountryCode | string
    disabled?: boolean
    isCountry?: boolean
  }>(),
  {
    isCountry: true,
  },
)
</script>
